import React, { useState } from "react";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link,Navigate } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import { setAccessToken } from "../../api/axiosInstance";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import Breadcrump from "../../components/Breadcrump";
import { useNavigate } from "react-router-dom";

const Login = () => {
  useAlphabeticInput();

  const INITIAL_FORM_DATA = {
    email: "",
    password: "",
  };
  const [activeTab, setActiveTab] = useState("login");
  const variants = {
    hidden: { opacity: 0, y: 15, filter: "blur(5px)" },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.6, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      y: -15,
      filter: "blur(5px)",
      transition: { duration: 0.3 },
    },
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);
  const isValidPassword = formData.password.length >= 6;

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please Enter Email Address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.password) {
      newErrors.password = "Enter Password";
    } else if (!isValidPassword) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  try {
    const res = await userAPI.login(formData);

    if (res.code === 200) {
      showSuccess(res.message);

      localStorage.setItem("token", JSON.stringify({
        email: res.data.email,
        username: res.data.username,
      }));

      localStorage.setItem("accessToken", res.data.accessToken);

      navigate("/users/dashboard"); // ✅ correct
    }
  } catch (err) {
    showError(err.message);
  }
};
  return (
    <>
      <Breadcrump title="Login" />
      <div className="portal-wrapper">
        <div className="portal-container">
          {/* --- 1. THE FLOATING ARCH IMAGE (Left) --- */}
          <div className="portal-image-arch">
            <img src={`${process.env.PUBLIC_URL}/images/login-register.png`} alt="Ritual" className="portal-img" />
            {/* Gradient overlay for text readability */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to top, rgba(44, 58, 49, 0.7), transparent)",
              }}
            ></div>

            <div className="portal-quote">
              <Sparkles
                className="mb-2 text-white opacity-75"
                size={24}
                style={{ margin: "0 auto" }}
              />
              <p className="quote-text">"Where science meets the sacred."</p>
            </div>
          </div>

          {/* --- 2. THE FORM CARD (Right) --- */}
          <div className="portal-form-card">
            {/* GOLD PILL TOGGLE */}

            <AnimatePresence mode="wait">
              {/* --- LOGIN FORM --- */}
              {activeTab === "login" && (
                <motion.div
                  key="login"
                  variants={variants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                >
                  <h1 className="form-headline">Sign In</h1>

                  <form onSubmit={handleSubmit}>
                    <div className="portal-input-group">
                      <input
                        type="email"
                        className="portal-input"
                        name="email"
                        placeholder=""
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <label className="portal-label  px-2">Email Address</label>
                      {errors && errors.email && (
                        <span className="text-danger">{errors.email}</span>
                      )}
                    </div>

                    <div className="portal-input-group">
                      <input
                        type="password"
                        className="portal-input"
                        name="password"
                        placeholder=""
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <label className="portal-label  px-2">Password</label>
                      {errors && errors.password && (
                        <span className="text-danger">{errors.password}</span>
                      )}
                    </div>

                    <button className="btn-portal" type="submit">
                      Login <ArrowRight size={16} className="ms-2" />
                    </button>
                    <div className="d-flex justify-content-between align-items-center mb-5 mt-2">
                      <label
                        className="small"
                        style={{
                          color: "var(--portal-text-soft)",
                          cursor: "pointer",
                          fontFamily: "var(--font-body)",
                        }}
                      >
                        <input
                          type="checkbox"
                          className="me-2"
                          style={{ accentColor: "var(--portal-accent)" }}
                        />{" "}
                        Don't have an account
                      </label>
                      <Link
                        to="/users/register   "
                        className="small text-decoration-none"
                        style={{
                          color: "var(--portal-text-deep)",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        Sign up
                      </Link>
                    </div>
                  </form>
                </motion.div>
              )}

              {/* --- REGISTER FORM --- */}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
